import { Injectable } from '@angular/core';
import { Client, Databases, Models, Query } from 'appwrite';
import { environment } from '../../../../../environments/environment';
import { databases } from '@shared/helpers/appwrite';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private client: Client;
  private databases: Databases;

  constructor() {
    this.client = new Client()
      .setEndpoint(environment.apiUrl)
      .setProject(environment.appwrite.projectId);

    this.databases = new Databases(this.client);
  }

  async getProperties(): Promise<Models.Document[]> {
    console.log('Api base url', environment.apiUrl);
    console.log('Project id', environment.appwrite.projectId);
    console.log('Database id', environment.appwrite.databaseId);
    console.log('Collection id', environment.appwrite.collectionIdProperties);

    const response = await this.databases.listDocuments(
      environment.appwrite.databaseId,
      environment.appwrite.collectionIdProperties
    );

    // const filteredProperties = await databases.listDocuments(
    //   '1234',
    //   'fdfdfdf2423423',
    //   [
    //     Query.equal('status', 'active'),
    //     Query.greaterThan('price', 100000),
    //     Query.orderDesc('createdAt'),
    //     Query.limit(10),
    //   ]
    // );

    return response.documents;
  }

  async getPropertyById(propertyId: string): Promise<Models.Document> {
    return await this.databases.getDocument(
      environment.appwrite.databaseId,
      environment.appwrite.collectionIdProperties,
      propertyId
    );
  }
}
